import { Router } from '@angular/router';

import { PortalType } from '../_models/models';


export function resolvePortalType(router: Router): PortalType {
  let portalType: PortalType = null;
  let route = router.routerState.root;

  while (route) {
    if (route.snapshot.data?.portalType) {
      portalType = route.snapshot.data.portalType;
    }
    route = route.firstChild;
  }

  return portalType;
}
